import { render, staticRenderFns } from "./Processing.vue?vue&type=template&id=2961e1f4"
import script from "./Processing.vue?vue&type=script&lang=js"
export * from "./Processing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports